import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import SiteHeader from '@/components/generals/site-header'
import SiteFooter from '@/components/generals/site-footer'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#contenu'
                className='sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[60] focus:rounded-full focus:bg-foreground focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-background'
            >
                Aller au contenu
            </a>

            <SiteHeader />

            <main id='contenu' className='flex-1'>
                {children}
            </main>

            <SiteFooter />
        </div>
    )
}
